import { Directive, EventEmitter, Output, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appDebounceClick]',
  standalone: false
})
export class DebounceClickDirective implements OnInit, OnDestroy {
  @Output() debounceClick = new EventEmitter();

  private clicked = new Subject();
  ngUnsubscribe: Subject<void> = new Subject();
  constructor() {}
  ngOnInit() {
    this.clicked.pipe(debounceTime(500), takeUntil(this.ngUnsubscribe)).subscribe(event => {
      this.debounceClick.emit(event);
    });
  }

  ngOnDestroy() {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent | TouchEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.clicked.next(event);
  }
}
